interface Props {
  date?: string | undefined
}

const NEW_QUESTION_THRESHOLD_DAYS = process.env
  .NEXT_PUBLIC_NEW_QUESTION_PILLOW_VALUE as any

function NewBadge({ date = undefined }: Props) {
  if (
    !date ||
    new Date(date) <
      new Date(
        new Date().getTime() -
          NEW_QUESTION_THRESHOLD_DAYS * 24 * 60 * 60 * 1000,
      )
  ) {
    return null
  }
  return (
    <span
      className="ml-3 rounded-full border bg-transparent px-4 py-1 font-semibold shadow"
      style={{
        borderColor: 'var(--color-border)',
        color: 'var(--color-orange-400)',
      }}
    >
      New
    </span>
  )
}

export default NewBadge
